export default __webpack_public_path__ + "e3812021b3776a5c6ec77d3c2eb95586.jpg";